import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory as history } from 'react-router';
import moment from "moment";

import LoadingControl from '../../../../components/LoadingControl';
import TeamProfilePresentationCalibrationControl from '../../../../components/v3/CalibrationScreenV3/TeamProfilePresentationCalibrationControl';
import CalibrationV3AgentScreen from '../agents/CalibrationV3AgentScreen';
import TeamOverTimeGraphs from './graphs/TeamOverTimeGraphs';
import AgentsTableForSupervisor from './agents/AgentsTableForSupervisor';

import { dateFormat } from '../../../../constants';
import { ZRole } from '../../../../generated';
import { pageLoaded, isDefined, isJibedOnAllQuestions, arrayIsNotEmpty } from '../../../../utils';

import {
    updateProps,
    loadJibeSupervisorScreen,
    loadProgressOverTimeStats,
} from '../CalibrationV3ScreenActions';

import {
    fetchUserTeamsStats
} from '../../../../api/v3/DataApi';

class CalibrationV3SupervisorScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDate: moment().startOf('day').subtract(7, 'd').format(dateFormat),
            toDate: moment().endOf('day').format(dateFormat),
        };

        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);
        this.onSelectAgent = this.onSelectAgent.bind(this);
        this.getTopPanelNode = this.getTopPanelNode.bind(this);
    }

    componentDidMount() {
        pageLoaded('Jibe');
      
        fetchUserTeamsStats()
            .then(payload => this.loadData(payload.result))
            .catch(error => console.error(error));
    }

    loadData(teams) {
        if (arrayIsNotEmpty(teams)) {
            const defaultTeam = teams[0];
            this.props.dispatch(loadJibeSupervisorScreen(this.state.fromDate, this.state.toDate, defaultTeam.id));
        }       
    }

    onSelectNewTimeRange(fromDate, toDate, selectedTimePeriodicity) {
        this.props.dispatch(updateProps({ progressOverTimeStatsForOwnTeam: undefined }));
        this.props.dispatch(loadProgressOverTimeStats(fromDate, toDate, selectedTimePeriodicity,));
    }

    onSelectAgent(userId) {
        const
            {
                teamsCalibrationStatsForOwnTeam,
            } = this.props;
        const selectedAgent = (teamsCalibrationStatsForOwnTeam && teamsCalibrationStatsForOwnTeam.agents)
            ? teamsCalibrationStatsForOwnTeam.agents.find(t => t.id === userId)
            : undefined;

        this.props.dispatch(updateProps({ selectedAgent: selectedAgent }));
        history.push(`/Jibe/status/agent/${userId}`);
    }

    getTopPanelNode() {
        const
            {
                currentTeamAgentsCalibrationStats,
                calibratedOnSurveyQuestions,
                userTeamsStats,
            } = this.props;
        const teamName = arrayIsNotEmpty(userTeamsStats)
            ? userTeamsStats[0].name
            : undefined;

        if (!isDefined(currentTeamAgentsCalibrationStats) || !isDefined(calibratedOnSurveyQuestions)) {
            return <LoadingControl />;
        }

        const fullyJibedAgentsCount = currentTeamAgentsCalibrationStats.filter(a => isJibedOnAllQuestions(a, calibratedOnSurveyQuestions)).length;
        const jibeSessionsPast30DaysCount = currentTeamAgentsCalibrationStats.map(i => i.jibeSessionsPast30DaysCount).reduce((a, b) => a + b, 0);

        const topPanelNode =
            <TeamProfilePresentationCalibrationControl
                name={teamName}
                agentCount={currentTeamAgentsCalibrationStats.length}
                fullyJibedAgentsCount={fullyJibedAgentsCount}
                jibeSessionsPast30DaysCount={jibeSessionsPast30DaysCount}
                backgroundImage="profileAgentWithAvatar" />

        return topPanelNode;
    }

    render() {
        const
            {
                currentUser,
            } = this.props;
        if (!currentUser) {
            return <LoadingControl />;
        }
        if (currentUser.RoleId == ZRole.Agent) {
            return <CalibrationV3AgentScreen />
        }

        const topPanelNode = this.getTopPanelNode();

        return (
            <div className="main-page-width">
                <div style={{ margin: '20px 0' }}>
                    {topPanelNode}
                </div>
                <TeamOverTimeGraphs
                    onSelectNewTimeRange={this.onSelectNewTimeRange} />
                <br />
                <AgentsTableForSupervisor
                    onSelectAgent={(userId) => this.onSelectAgent(userId)} />
                <br />
                <br />
            </div >);
    }
}

const select = state => ({ ...state.CalibrationV3Screen, ...state.session });

export default connect(select)(CalibrationV3SupervisorScreen);